import React from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../../../../../features/components/PageSection'
import InstagramSocialPostCard from './InstagramSocialPostCard'

import useStyles from '../styles'

const InstagramSocialPosts = ({ posts, facebookPageData }) => {
  const classes = useStyles()

  return (
    <PageSection>
      <ul className={classes.cardsList}>
        {posts.map((post, index) => (
          <InstagramSocialPostCard key={index} post={post} facebookPageData={facebookPageData} />
        ))}
      </ul>
    </PageSection>
  )
}

InstagramSocialPosts.propTypes = {
  posts: PropTypes.array.isRequired,
  facebookPageData: PropTypes.object
}

export default InstagramSocialPosts
